import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from "@angular/core";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from "@medsurf/flat-facades";

@Component({
    selector: 'medsurf-slide-edit-marker',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './marker.component.html',
    styleUrls: ['./marker.component.scss'],
    standalone: false
})
export class MarkerComponent {
  @ViewChild('edit_overlay_template_scroll_panel', {static: false}) editPanelScrollPanel: ElementRef<HTMLDivElement>;
  
  annotation: FlatModels.AnnotationEntityModels.Marker;
  readonly FlatModels = FlatModels;
  
  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Annotation
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((annotation) => {
      if (this.annotation?.id !== annotation?.id && this.editPanelScrollPanel) {
        this.editPanelScrollPanel.nativeElement.scrollTop = 0;
      }
      this.annotation = structuredClone(annotation) as FlatModels.AnnotationEntityModels.Marker;
    });
  }
}
